import { AppDispatch } from '../../redux/store';
import CustomInput from '../reusable/input';
import { fetchTeamThunk } from '../../redux/thunks/team';
import SendInviteModal from './modal/send_invite';
import TeamCardComponent from './team_card';
import TeamTableComponent from './team_table';
import { useDispatch } from 'react-redux';
import { Box, Button, InputAdornment, Typography } from '@mui/material';
import { CardMembership, PersonAddAlt, SearchOutlined, SortOutlined, TableChartOutlined } from '@mui/icons-material';
import { useEffect, useState } from 'react';

const TeamComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [sendInvite, setSendInvite] = useState<boolean>(false);
    const [searchValue, setSearchValue] = useState<string>('');
    const [isCardView, setIsCardView] = useState<boolean>(false);
    const [sort, setIsSort] = useState<boolean>(false);

    useEffect(() => {
        const fetchTeamMembers = async () => {
            try {
                await dispatch(fetchTeamThunk()).unwrap();
            } catch (e) {
                // Catch errors
            }
        };
        fetchTeamMembers();
    }, []);

    return (
        <Box>
            <Typography variant="h3" color="textSecondary" mt={2}>Team Accounts</Typography>
            <Typography variant="body1" color="textSecondary" my={1}>Manage user roles to ensure data security</Typography>
            <Box display="flex" gap={2} mb={2}>
                <Box>
                    <CustomInput
                        placeholder="Search"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchOutlined />
                                    </InputAdornment>
                                )
                            }
                        }}
                    />
                </Box>
                <Button variant="outlined" color={sort ? 'primary' : 'secondary'} onClick={() => setIsSort(!sort)} startIcon={<SortOutlined />}>Sort</Button>
                <Button variant="outlined" color="secondary" onClick={() => setIsCardView(!isCardView)} startIcon={isCardView ? <TableChartOutlined /> : <CardMembership />}>
                    {isCardView ? 'Table View' : 'Card View'}
                </Button>
                <Button variant="outlined" onClick={() => setSendInvite(true)} startIcon={<PersonAddAlt />}>Send Invite</Button>
            </Box>
            {
                isCardView ? <TeamCardComponent sort={sort} search={searchValue} /> : <TeamTableComponent sort={sort} search={searchValue} />
            }
            <SendInviteModal open={sendInvite} onClose={() => setSendInvite(false)} />
        </Box>
    );
};

export default TeamComponent;